import checkmark from "images/icons/checkmark.svg"
import { formatHexColorValue } from "shared/lib/alternate_brand_color"
import "./onboarding_tile.scss"
import classNames from "classnames"

interface OnboardingItem {
  backgroundStyle?: string
  brand_color?: string
  color?: string
  icon?: string
  lrg_monochrome_image_url?: string
  module_name?: string
  name: string
}

interface Props {
  isPlatformSelect?: boolean
  selected: boolean
  onboardingItem: OnboardingItem
  onClick: () => void
}

const OnboardingTile = ({ selected, onboardingItem, onClick, isPlatformSelect }: Props) => (
  <a
    style={{
      background: `${
        isPlatformSelect ? onboardingItem.backgroundStyle : formatHexColorValue(onboardingItem.brand_color)
      }`,
      color: `${onboardingItem.color || "none"}`,
    }}
    onClick={onClick}
    styleName={classNames("inner-tile", {
      "platform-select": isPlatformSelect,
    })}
  >
    {onboardingItem.lrg_monochrome_image_url && (
      <img styleName="onboarding-icon" src={onboardingItem.lrg_monochrome_image_url} />
    )}
    {onboardingItem.icon && <span dangerouslySetInnerHTML={{ __html: onboardingItem.icon }} />}
    <div>{onboardingItem.name}</div>
    {selected ? (
      <div styleName="selection-icon" dangerouslySetInnerHTML={{ __html: checkmark }} />
    ) : (
      <div styleName="unselected selection-icon" />
    )}
  </a>
)

export default OnboardingTile
